import { render, staticRenderFns } from "./shopFocusContainer.vue?vue&type=template&id=fdfda97a&scoped=true&"
import script from "./shopFocusContainer.vue?vue&type=script&lang=js&"
export * from "./shopFocusContainer.vue?vue&type=script&lang=js&"
import style0 from "./shopFocusContainer.vue?vue&type=style&index=0&id=fdfda97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfda97a",
  null
  
)

export default component.exports